import { Component, OnInit, ChangeDetectorRef, Input } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { BreadcrumbService } from "./breadcrumb.service";
import { BreadcrumbLink } from "../../models/Breadcrumb";
import { Utilities } from "../../utilities";
import { TCCPCommonService } from "../../services/tccp-common.service";
import { TCCPLocalStorageService } from "../../services/tccp-local-storage.service";
import { FlowInformationComponent } from "../flow-information/flow-information.component";
import { environment } from "../../../../environments/environment";
import _ from "lodash";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
  public route: string;
  public breadcrumbList: Array<BreadcrumbLink> = [];
  public breadcrumbLinksList: Array<any> = [];
  public appName = environment.applicationName;
  public resetBredcrumb: Array<any> = [];
  public showBreadcrumb = false;
  public showVINDisclaimer = false;
  public breadcrumbsSubject: any;
  public flowInformation: FlowInformationComponent;
  @Input() isPreviewMode: boolean = false;
  constructor(
    private commonService: TCCPCommonService,

    private breadcrumbService: BreadcrumbService,
    private cdRef: ChangeDetectorRef,
    public storageService: TCCPLocalStorageService,
    public router: Router
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.onUrlChange(event.url);
      });
    this.breadcrumbService.showBreadcrumb.subscribe(
      (data) => {
        if (data) {
          this.breadcrumbList = [];
          this.breadcrumbLinksList = [];
          this.breadcrumbList[0] = this.storageService.getHome();
          const subTopic = this.storageService.getSubTopic();
          const supportTopics = this.storageService.getSupportTopics();
          const feature = this.storageService.getFeature();
          const vehicleModel = this.storageService.getVehicleModel();
          const vehicleYear = this.storageService.getVehicleYear();
          if (
            vehicleModel &&
            vehicleModel.name &&
            vehicleModel.name !== "" &&
            vehicleModel.name !== undefined
          ) {
            this.breadcrumbList[1] = vehicleModel;
          }
          if (
            vehicleYear &&
            vehicleYear.name &&
            vehicleYear.name !== "" &&
            vehicleYear.name !== undefined
          ) {
            this.breadcrumbList[2] = vehicleYear;
          }
          if (
            supportTopics &&
            supportTopics.name &&
            supportTopics.name !== "" &&
            supportTopics.name !== undefined
          ) {
            this.breadcrumbList[3] = supportTopics;
            this.breadcrumbList[3].name =
              this.breadcrumbList[3].name.toUpperCase();
          }
          if (
            feature &&
            feature.name &&
            feature.name !== "" &&
            feature.name !== undefined
          ) {
            this.breadcrumbList[4] = feature;
            this.breadcrumbList[4].name =
              this.breadcrumbList[4].name.toUpperCase();
          }
          if (subTopic && subTopic.name && subTopic.name !== "") {
            this.breadcrumbList[5] = subTopic;
            this.breadcrumbList[5].name =
              this.breadcrumbList[5].name.toUpperCase();
          }
          for (let i = 0; i <= this.breadcrumbList.length; i++) {
            if (
              this.breadcrumbList[i] &&
              this.breadcrumbList[i] !== undefined &&
              this.breadcrumbList[i].name !== ""
            ) {
              this.breadcrumbLinksList.push(this.breadcrumbList[i]);
            }
            this.breadcrumbLinksList = Utilities.getUniqueList(
              this.breadcrumbLinksList
            );
          }
        }
      },
      (error) => {}
    );

    this.breadcrumbService.clearBreadcrumb.subscribe(
      (data) => {
        if (data) {
          this.breadcrumbLinksList = [];
        }
      },
      (error) => {}
    );
  }

  onUrlChange(url: string) {
    this.checkCurrentBreadcrumb(url);
  }

  checkCurrentBreadcrumb(currentUrl: string) {
    const matchingBreadcrumb = this.breadcrumbLinksList.find(
      (breadcrumb) => breadcrumb.link === currentUrl
    );

    if (matchingBreadcrumb) {
      this.trimBreadcrumbsAfter(matchingBreadcrumb.link);
    }
  }

  trimBreadcrumbsAfter(link: string) {
    const index = this.breadcrumbLinksList.findIndex(
      (breadcrumb) => breadcrumb.link === link
    );
    if (index !== -1) {
      this.breadcrumbLinksList = this.breadcrumbLinksList.slice(0, index + 1); // Keep breadcrumbs up to the matched link
      this.nullifyStorageValuesAfterIndex(index);
    }
  }

  nullifyStorageValuesAfterIndex(index: number) {
    for (let i = index + 1; i < this.breadcrumbList.length; i++) {
      const breadcrumb = this.breadcrumbList[i];
      if (breadcrumb) {
        switch (breadcrumb.type) {
          case "SUBTOPIC":
            this.storageService.setSubTopic(null, null);
            break;
          case "FEATURE":
            this.storageService.setFeature(null, null);
            break;
          case "SUPPORTTOPICS":
            this.storageService.setSupportTopics(null, null);
            break;
          case "YEAR":
            this.storageService.setVehicleYear(null, null);
            break;
          case "MODEL":
            this.storageService.setVehicleModel(null, null);
            break;
          case "HOME":
            this.storageService.setVehicleVin(null, null);
            this.storageService.setVin(null);
            break;
        }
      }
    }
  }

  showBreadcrumbFn() {
    return (
      this.breadcrumbLinksList.length !== 0 &&
      this.router.url.indexOf("home") === -1
    );
  }

  showVINDisclaimerFn() {
    const feature = this.storageService.getFeature();
    const vin = this.storageService.getVehicleVin();
    return vin && vin.name && vin.name !== ""
      ? feature && feature.name === ""
        ? true
        : false
      : false;
  }

  ngAfterViewChecked() {
    const showBreadcrumb = this.showBreadcrumbFn();
    const showVINDisclaimer = this.showVINDisclaimerFn();
    if (showBreadcrumb !== this.showBreadcrumb) {
      this.showBreadcrumb = showBreadcrumb;
      this.cdRef.detectChanges();
    }
    if (showVINDisclaimer !== this.showVINDisclaimer) {
      this.showVINDisclaimer = showVINDisclaimer;
      this.cdRef.detectChanges();
    }
  }
  setPreviewMode(isPreview: boolean) {
    this.isPreviewMode = isPreview;
    if (isPreview) {
      this.breadcrumbList = [];
      this.breadcrumbLinksList = [];
    }
  }

  updateBreadcrumbLinksList() {
    this.breadcrumbLinksList = [];
    for (let i = 0; i < this.breadcrumbList.length; i++) {
      if (this.breadcrumbList[i] && this.breadcrumbList[i].name !== "") {
        this.breadcrumbLinksList.push(this.breadcrumbList[i]);
      }
    }
    this.breadcrumbLinksList = Utilities.getUniqueList(
      this.breadcrumbLinksList
    );
  }

  public navigateURL(breadcrumb) {
    if (breadcrumb && breadcrumb.type === "SUBTOPIC") {
      this.commonService.clearFlowPage.emit(breadcrumb.type);
      this.commonService.hideModelYearSection.emit(true);
    } else if (breadcrumb && breadcrumb.type === "FEATURE") {
      this.storageService.setSubTopic(null, null);
      this.commonService.clearFlowPage.emit(breadcrumb.type);
      this.commonService.hideModelYearSection.emit(true);
    } else if (breadcrumb && breadcrumb.type === "SUPPORTTOPICS") {
      this.storageService.setSubTopic(null, null);
      this.storageService.setFeature(null, null);
      this.commonService.clearDashboardPage.emit(breadcrumb.type);
      this.commonService.hideModelYearSection.emit(true);
    } else if (breadcrumb && breadcrumb.type === "YEAR") {
      this.storageService.setSubTopic(null, null);
      this.storageService.setSupportTopics(null, null);
      this.storageService.setFeature(null, null);
      this.commonService.changeLayoutStyle.emit(true);
      this.commonService.clearHomePage.emit(breadcrumb.type);
      this.commonService.hideBanner.emit(false);
      this.commonService.hideModelYearSection.emit(true);
    } else if (breadcrumb && breadcrumb.type === "MODEL") {
      this.storageService.setSubTopic(null, null);
      this.storageService.setSupportTopics(null, null);
      this.storageService.setVehicleYear(null, null);
      this.storageService.setFeature(null, null);
      this.commonService.changeLayoutStyle.emit(true);
      this.commonService.clearHomePage.emit(breadcrumb.type);
      this.commonService.hideModelYearSection.emit(true);
      this.commonService.hideBanner.emit(false);
    } else if (breadcrumb && breadcrumb.type === "HOME") {
      this.storageService.setSubTopic(null, null);
      this.storageService.setSupportTopics(null, null);
      this.storageService.setFeature(null, null);
      this.storageService.setVehicleYear(null, null);
      this.storageService.setVehicleModel(null, null);
      this.storageService.setVehicleVin(null, null);
      this.storageService.setVin(null);
      this.commonService.clearHomePage.emit(breadcrumb.type);
      this.commonService.changeLayoutStyle.emit(true);
      this.breadcrumbService.clearBreadcrumb.emit(true);
      //  this.commonService.hideBanner.emit(false);
      this.commonService.hideModelYearSection.emit(false);
    }
  }
}
